import Login from "./pages/Login/Login";
import Sidebar from "./layout/Sidebar";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home/Home";
import Connector from "./pages/Connector/Connector";
import React, { useEffect } from "react";
import axios from "./api/Config/index";
import { useSelector, useDispatch } from "react-redux";
import { TestVerify, UsersOrg, VerifySessionToken } from "./api/Actions/SsoB3/SsoB3";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  return <Route component={<Connector />} />;
};

const App = () => {
  const dispatch = useDispatch();
  const login = useSelector((state) => state.ReduxState.login);
  const VerifySession = useSelector((state) => state.UsersLogin.VerifySession);
  const errorVerifySession = useSelector((state) => state.UsersLogin.errorVerifySession);

  const Protected = ({ isLoggedIn, children }) => {
    if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };
  const ProtectedLogin = ({ isLoggedIn, children }) => {
    if (isLoggedIn) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  useEffect(() => {
    dispatch({
      type: "set",
      login: localStorage.getItem("sessionToken") && localStorage.getItem("orgUuid") ? true : false,
    });

    if (localStorage.getItem("sessionToken") && localStorage.getItem("orgUuid")) {
      // verify session token
      dispatch(TestVerify());
    } else {
    }
  }, []);

  useEffect(() => {
    // verify session
    if (localStorage.getItem("identityUuid")) {
      const userId = localStorage.getItem("identityUuid");
      dispatch(UsersOrg(userId));
      if (VerifySession.success === true) {
        dispatch({ type: "set", login: true, menu: "/" });
        axios.defaults.headers["domain"] = localStorage.getItem("domain");
      }
      if (errorVerifySession) {
        dispatch({ type: "set", login: false, loginProcess: "domain" });
        localStorage.clear();
      }
    } else {
      dispatch({ type: "set", login: false, loginProcess: "domain" });
      localStorage.clear();
    }
  }, [VerifySession]);

  return (
    <Router>
      <div className="flex flex-row h-screen overflow-auto w-max-screen">
        <div className="flex flex-row h-max-screen">{login ? <Sidebar /> : ""}</div>
        <div className="flex w-full">
          <Routes className="w-full h-max-screen">
            <Route
              path="/login"
              element={
                <ProtectedLogin isLoggedIn={login}>
                  <Login />
                </ProtectedLogin>
              }
            />
            <Route
              path="/"
              element={
                <Protected isLoggedIn={login}>
                  <Home />
                </Protected>
              }
            />
            <Route
              path="/connector"
              element={
                <Protected isLoggedIn={login}>
                  <Connector />
                </Protected>
              }
            />
            <Route
              path="*"
              element={
                <Protected isLoggedIn={login}>
                  <div>404 Page Not Found</div>
                </Protected>
              }
            />
            {/* <ProtectedRoute path="/home" name="Home" component={Home} replace /> */}
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
